import {
    watch,
    type ComputedRef,
    type WritableComputedRef,
    onMounted,
    type Ref,
} from 'vue'
import { useCarousel } from '@/components/layout/carousels/base/useCarouselNew'
import type { GalleryWithEnquiryCardFragment } from '@/graphql/api'

export function useComponentGalleryWithEnquiryMobile(
    isMobile: ComputedRef<boolean>,
    items: Readonly<Ref<GalleryWithEnquiryCardFragment[]>>,
    currentItem: WritableComputedRef<
        GalleryWithEnquiryCardFragment | undefined
    >,
    currentItemIndex: ComputedRef<number>
) {
    const {
        container: containerMobile,
        elements: itemElsMobile,
        current: currentMobileElIndex,
        previous: previousMobile,
        next: nextMobile,
    } = useCarousel(items, false, undefined, 'smooth')

    watch(currentMobileElIndex, (newCurrent) => {
        currentItem.value = items.value[newCurrent]
    })

    onMounted(() => {
        if (!isMobile.value) {
            return
        }

        const index = currentItemIndex.value

        if (index !== -1) {
            currentMobileElIndex.value = index
        }
    })

    return {
        containerMobile,
        itemElsMobile,
        previousMobile,
        nextMobile,
    }
}
